"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { SortDirection } from "@/entities/ISort";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import { CommunityMembersSortOption } from "@/enums";
export default function CommunityMembersTableHeaderSortableContent(t0) {
  const $ = _c(20);
  const {
    sort,
    activeSort,
    sortDirection,
    hoveringOption,
    isLoading
  } = t0;
  const isActive = sort === activeSort;
  const direction = isActive ? sortDirection : SortDirection.DESC;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [CommunityMembersSortOption.DISPLAY]: "Profile",
      [CommunityMembersSortOption.LEVEL]: "Level",
      [CommunityMembersSortOption.TDH]: "TDH",
      [CommunityMembersSortOption.REP]: "REP",
      [CommunityMembersSortOption.NIC]: "NIC"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const TITLE = t1;
  const [rotate, setRotate] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setRotate(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== sortDirection) {
    t3 = [sortDirection];
    $[2] = sortDirection;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== hoveringOption || $[5] !== isActive || $[6] !== sort) {
    t4 = () => setRotate(isActive && hoveringOption === sort);
    t5 = [hoveringOption, isActive, sort];
    $[4] = hoveringOption;
    $[5] = isActive;
    $[6] = sort;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const showLoader = isLoading && isActive;
  const t6 = `${isActive ? "tw-text-primary-400" : "group-hover:tw-text-iron-200"} tw-transition tw-duration-300 tw-ease-out`;
  const t7 = TITLE[sort];
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <span className={t6}>{t7}</span>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== direction || $[13] !== isActive || $[14] !== rotate || $[15] !== showLoader) {
    t9 = showLoader ? <span className="tw-pl-2"><CircleLoader size={CircleLoaderSize.SMALL} /></span> : <span className="-tw-mt-0.5 tw-ml-2"><CommonTableSortIcon direction={direction} isActive={isActive} shouldRotate={rotate} /></span>;
    $[12] = direction;
    $[13] = isActive;
    $[14] = rotate;
    $[15] = showLoader;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}